import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const AboutPage = () => {
  return (
    <Wrapper>
      <div className="about-area inner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-thumb">
                <img src="/assets/images/about-img/about img.png" alt="" />
              </div>
            </div>
            <div className="col-lg-6 upper">
              <div className="section-title two">
                <h1>Eque Heritage Hotel & Resort</h1>
                <h1 className="fs-3">Saidpur, Nilphamari</h1>
                <p className="section-desc-2" style={{ textAlign: "justify" }}>
                  Welcome to Eque Heritage Hotel and Resort, your perfect place
                  for peace and luxury, where beautiful nature and amazing
                  service come together. Begin your day with the soft sounds of
                  birds singing in the morning, creating a calm and relaxing
                  vibe. Surrounded by nature’s beauty, our resort is a peaceful
                  getaway from the busy world, giving you a refreshing and
                  relaxing experience in a quiet and serene environment.
                </p>
              </div>

              <div className="section-desc-2">
                <p className="text-dark mb-0 mt-4">
                  Airport Road, Near By Fivestar Play Ground, Saidpur-5310,
                  Nilphamari, Bangladesh
                </p>
              </div>
              <div className="d-flex justify-content-start align-items-center gap-2 lluxury-button">
                <div className="luxury-button">
                  <Link to="/room">Accommodation</Link>
                </div>
                <div className="luxury-button">
                  <Link to="/service">Services</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .inner.about-area .col-lg-6.upper {
    padding-left: 17px;
    padding-right: 17px;
  }

  @media screen and (max-width: 425px) {
    .lluxury-button {
      justify-content: center !important;
    }

    .luxury-button a {
      display: inline-block;
      background: #c19d68;
      padding: 13px 15px;
      font-size: 16px;
      text-transform: uppercase;
      color: #ffffff;
      font-weight: 500;
      font-family: "Cormorant Garamond";
      position: relative;
      z-index: 1;
      border: 1px solid #c19d68;
      transition: 0.5s;
      text-align: center;
    }
  }
`;

export default AboutPage;
